import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReasonMapDal } from '../dal/reasonMap.dal';
import { ReasonMap } from '../models/reasonMap.model';

@Injectable({
  providedIn: 'root',
})
export class ReasonMapService {
  constructor(private reasonMapDal: ReasonMapDal) {}

  getSuggestedReasonsMaps(
    includeNotSuggested: boolean = false,
    populateRules: boolean = false
  ): Observable<ReasonMap[]> {
    return this.reasonMapDal.getSuggestedReasonsMaps(includeNotSuggested, populateRules);
  }

  getAllReasonsMaps(
    page: number = 1,
    limit: number = 10,
    positions: string[] = [],
    sort?: { field: string; direction: number },
    search?: { [key: string]: string }
  ): Observable<{ [key: string]: any }> {
    return this.reasonMapDal.getAllReasonsMaps(page, limit, positions, sort, search);
  }

  createReasonMap(reasonMap: ReasonMap): Observable<ReasonMap> {
    return this.reasonMapDal.createReasonMap(reasonMap);
  }

  updateReasonMap(reasonMap: ReasonMap): Observable<ReasonMap> {
    return this.reasonMapDal.updateReasonMap(reasonMap);
  }

  getTmpReasonMap(profile: string, programs: any[]) {
    return this.reasonMapDal.getTmpReasonMap(profile, programs);
  }

  getVacations(date: string) {
    return this.reasonMapDal.getVacations(date);
  }

  getNightReasonsMaps() {
    return this.reasonMapDal.getNightReasonsMaps();
  }
}
